encodedPath